import type { CourierTransaction } from 'common/api/api-types';
import type { CourierWithExtraInfo } from 'common/hooks/useMergeCourierExtraInfo';

import { useMemo } from 'react';
import { styled } from 'styled-components';

import { typographyCss } from '@creditornot/cb-ingredients';

import { useNumberFormatter } from 'common/hooks/useNumberFormatter';
import { calculateTotalEarnings } from 'features/earnings/useAggregatedColumns';
import { getAmountToDisplay } from 'features/earnings/utils';

const Root = styled.div`
  ${typographyCss.Body3({ weight: 'semiBold' })};
`;

const TotalAmount: React.FC<{
  earnings?: CourierWithExtraInfo['_extra']['earnings'];
  excludedTransactions: Array<CourierTransaction['transactionType']>;
  title: string;
}> = ({ earnings, title, excludedTransactions }) => {
  const numberFormatter = useNumberFormatter();
  const currency = earnings?.aggregatedTransactions?.[0]?.currency;
  const amount = useMemo(
    () =>
      calculateTotalEarnings({
        transactions: earnings?.aggregatedTransactions,
        excludedTransactionTypes: excludedTransactions,
      }),
    [earnings, excludedTransactions],
  );
  return (
    <Root title={title}>
      {getAmountToDisplay({
        decimalFormat: numberFormatter?.decimalFormat,
        amount,
        currency,
      })}
    </Root>
  );
};

export default TotalAmount;
